<template>
  <v-container
    id="schedule-list"
    fluid
    tag="section"
  >
    <div class="md-layout">
      <v-alert
        v-model="alert"
        :type="alertMessageType"
        dismissible
      >
        {{ alertMessageText }}
      </v-alert>


      <v-expansion-panels
        class="mb-0 schedule-filter"
      >
        <v-expansion-panel :class="'expanded_' + expandFilter">
          <v-expansion-panel-header @click="expandFilter = !expandFilter">Tìm kiếm lịch làm việc</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card
                    class="ma-0 mb-3"
                    outlined
            >
              <v-row>
                <v-col
                    cols="12"
                    md="3">
                  <v-menu
                      ref="menu_month"
                      :close-on-content-click="false"
                      :return-value.sync="month_picker"
                      transition="scale-transition"
                      offset-y
                      min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="month_picker"
                        label="Chọn tháng"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="month_picker" no-title scrollable @change="chooseMonth" type="month">
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                        cols="12"
                        md="3"
                >
                  <div
                          class="calendar-choose-week-block"
                  >
                    <label>Thời gian tìm kiếm</label>
                    <div class="btn-calendar-group">
                      <v-btn
                              class="ma-0 pa-0 btn-transparent"
                              text
                              small
                              @click="previousWeek"
                      >
                        <v-icon>
                          mdi-chevron-left
                        </v-icon>
                      </v-btn>
                      <span>{{ weekName }}</span>
                      <v-btn
                              class="ma-0 pa-0 btn-transparent"
                              text
                              small
                              @click="nextWeek"
                      >
                        <v-icon>
                          mdi-chevron-right
                        </v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-col>
                <v-col
                        cols="12"
                        md="3"
                >
                  <v-autocomplete
                          v-model="filterForm.shift"
                          :items="shiftListFilterForm"
                          label="Chọn ca làm việc"
                          placeholder="Ca làm việc"
                          item-text="label"
                          item-value="value"
                          clearable
                  >
                    <template v-slot:selection="data">
                      <v-chip
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              class="px-0 ma-0 bg-transparent"
                      >
                        <v-avatar
                                class="s-shift"
                                left
                        >
                    <span
                            class="bg-schedule-title"
                            :style="{background: data.item.color}"
                    />
                        </v-avatar>
                        {{ data.item.label }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-avatar class="s-shift">
                  <span
                          class="bg-color"
                          :style="{background: data.item.color}"
                  />
                      </v-list-item-avatar>
                      <v-list-item-content>
                        {{ data.item.label }}
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col
                        cols="12"
                        md="3"
                >
                  <div class="calendar-filter-group">
                    <v-autocomplete
                            v-model="filterForm.ministryIds"
                            label="Chọn bộ phận"
                            placeholder="Bộ phận"
                            no-data-text="Không có dữ liệu"
                            :items="ministries"
                            item-text="name"
                            item-value="id"
                            :error-messages="errors"
                            color="primary"
                            multiple
                            clearable
                    >
                      <template #prepend-item>
                        <common-select-all
                            v-model="filterForm.ministryIds"
                            :item="filterForm.ministryIds"
                            :items="ministries.map(s => s.id)"
                        ></common-select-all>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>
              <div class="text-center mt-2">
                <v-btn
                        class="primary mx-0"
                        @click="applyFilter"
                >
                  <v-icon>mdi-magnify</v-icon>Tìm kiếm
                </v-btn>
              </div>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-row class="mb-0 align-center schedule-info">
        <v-col cols="12" md="8">
          <schedule-statistic />
        </v-col>
        <v-col cols="12" md="4" v-if="checkAuthorization('schedule_create')" class="pt-0 pb-0">
          <div class="text-sm-right">
            <v-btn
              class="ma-2 ml-0 mr-0"
              color="primary"
              dark
              @click="openNewForm"
            >
              <v-icon
                dark
                left
              >
                mdi-plus
              </v-icon>
              Thêm lịch làm việc
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-card
        class="mx-auto pa-3 ma-0"
        outlined
      >
        <div class="table-calendar-container">
          <table class="table-calendar">
            <thead>
              <tr>
                <th class="scroll-layout-left th_team" ref="th_team">
                  Phòng ban
                </th>
                <th class="scroll-layout-left th_team" ref="th_team">
                  Teams
                </th>
                <th class="scroll-layout-left th_name" ref="th_name" :style="'left:' + sticky_name + 'px'">
                  Nhân viên
                </th>
                <th class="scroll-layout-left th_work" :style="'left:' + sticky_work + 'px'">
                  Số công
                </th>
                <th
                  v-for="colDate in colDates"
                  :key="colDate.date"
                >
                  {{ colDate.name }}
                </th>
              </tr>
            </thead>

            <tbody v-if="dataCalendarItems.length">
              <tr
                v-for="dataCalendarItem in dataCalendarItems"
                :key="dataCalendarItem.id"
              >
                <td
                    class="scroll-layout-left"
                    v-if="listOrgLv2Mapping['userId' + dataCalendarItem.userId]"
                    :rowspan="listOrgLv2Mapping['userId' + dataCalendarItem.userId].rowspan"
                >
                  {{ _.get(listOrgLv2Mapping['userId' + dataCalendarItem.userId], 'name') }}
                </td>
                <td
                  class="scroll-layout-left"
                  v-if="dataCalendarItem.index === 0"
                  :rowspan="_.get(dataCalendarItem, 'rowspan')"
                >
                  {{ _.get(dataCalendarItem, 'name') }}
                </td>
                <td class="scroll-layout-left"
                  :style="'left:' + sticky_name + 'px'">
                  {{ _.get(dataCalendarItem, 'fullName') }}
                </td>
                <td class="scroll-layout-left"
                  :style="'left:' + sticky_work + 'px'">
                  {{ _.get(dataCalendarItem, 'work') || 0}}
                </td>

                <template>
                  <td
                    style="cursor: pointer;"
                    v-for="colDate in colDates"
                    :key="`colval-${colDate.date}-${_.get(dataCalendarItem, 'index') }`"
                    class="no-padding"
                  >
                    <div
                      class="bg-schedule"
                      :class="getClassNameItems(_.get(_.get(dataCalendarItem, colDate.date, {}), 'items', []))"
                    >
                      <div
                        v-for="item in _.get(_.get(dataCalendarItem, colDate.date, {}), 'items', [])"
                        :key="item.id"
                        class="schedule-div-cell"
                        :class="getClassNameByStatus(item)"
                        @click="openEditForm(dataCalendarItem, item)"
                      >
                        {{getTextToDisplay(item)}}
                      </div>
                      <div 
                        class="schedule-div-cell"
                        v-if="_.get(_.get(dataCalendarItem, colDate.date, {}), 'items', []).length === 0"
                        @click="openCreateForm(dataCalendarItem, colDate.date)"
                        >
                      </div>
                    </div>
                  </td>
                </template>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="1000">
                  <common-no-result />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <edit-form />
        <v-dialog
          v-if="newDialog"
          v-model="newDialog"
          max-width="800"
          persistent
        >
          <schedule-form
            :group-users="groupUsers"
            :scheduleChoose="scheduleChoose"
          />
        </v-dialog>
      </v-card>
    </div>
  </v-container>
</template>

<script>
  import TokenService from '../../helpers/token';
  import RepositoryFactory from '@/repositories/RepositoryFactory'
  import { shiftListFilterForm } from '../../helpers/constants'
  import handleSchedule from '@/mixins/handleSchedule'
  import ScheduleForm from './ScheduleCreateForm'
  import ScheduleStatistic from './ScheduleStatistic'
  import EditForm from './ScheduleEditForm.vue'
  import * as moment from 'moment'
  const OrganizationMachineRepository = RepositoryFactory.get('organization_machine')
  const ScheduleRepository = RepositoryFactory.get('schedule')
  export default {
    components: {
      ScheduleForm,
      EditForm,
      ScheduleStatistic,
    },
    mixins: [handleSchedule],
    data () {
      return {
        shiftListFilterForm,
        scheduleList: [],
        ministries: [],
        dialog: false,
        newDialog: false,
        editDialog: false,
        alert: false,
        alertMessageText: null,
        alertMessageType: 'success',
        loading: false,
        currentWeekData: {},
        weekName: '',
        month_picker: '',
        colDates: [],
        dataCalendarItems: [],
        groupUsers: [],
        errors: [],
        filterForm: {
          ministryIds: [],
          shift: '',
        },
        statistics: {},
        scheduleChoose: {},
        sticky_name: '',
        sticky_work: '',
        expandFilter: false,
        watchModule: '',
        listOrgLv2: [],
        listOrgLv2Mapping: {}
      }
    },
    computed: {
    },
    created() {
      Bus.$on('schedule-list-reload', () => {
        this.fetchTableData()
      })
      Bus.$on('create-schedule-reload', () => {
        this.newDialog = false
        this.fetchTableData()
      })

      this.watchModule = this.$store.watch(
        (state) => {
          return state.module
        },
        async (newVal) => {
          this.filterForm = {
            ministryIds: [],
            shift: '',
          }
          await this.getUsers()
          await this.orgLevel2()
          this.fetchTableData()
        },
        {
          deep: true
        }
      )
    },
    updated() {
      setTimeout(() => {
        this.getHeightTable();
      }, 300);
      // count actual width of th_team after html rendered
      this.$nextTick( () => {
        this.sticky_name = this.$refs.th_team ? parseInt(this.$refs.th_team.clientWidth) : 0;
        this.sticky_work = this.$refs.th_team ? parseInt(this.$refs.th_name.clientWidth) + this.sticky_name : this.sticky_name;
      })
    },
    async mounted () {
      Bus.$on('close-schedule-form', () => {
        this.newDialog = false
      })
      Bus.$on('create-schedule-success', () => {
        this.newDialog = false
        this.fetchTableData()
      })
      this.currentWeekData = this.getCurrentWeek(new Date())
      this.updateCalendarDataDependsOn()
      await this.getUsers()
      await this.orgLevel2()
      this.fetchTableData()
    },
    beforeDestroy() {
      Bus.$off('close-schedule-form')
      Bus.$off('create-schedule-success')
      Bus.$off('create-schedule-reload')
      Bus.$off('schedule-list-reload')
      this.watchModule()
    },
    methods: {
      applyFilter () {
        this.fetchTableData()
        this.colDates = _.get(this.currentWeekData, 'daynamesMapping.nameHeaders', {})
      },
      chooseMonth () {
        this.$refs.menu_month.save(this.month_picker)
        this.currentWeekData = this.getCurrentMonth(this.month_picker)
        this.weekName = _.get(this.currentWeekData, 'weekName', {})
      },
      convertDataToViewCalendar () {
        const dataCalendarItems = []
        let tmpItem = {}
        let tmp = null
        let date = null
        const userDateStatus = {}
        let userWorkCount = {}
        if (this.scheduleList && this.scheduleList.length) {
          this.scheduleList.forEach((scheduleDataItem) => {
            const { userId, schedules = [] } = scheduleDataItem
            tmp = _.get(scheduleDataItem, 'date', '')
            tmp = tmp.split(' ')
            date = tmp[0]
            if (!(userId in userDateStatus)) {
              userDateStatus[userId] = {}
            }
            if (!(date in userDateStatus[userId])) {
              userDateStatus[userId][date] = {
                items: [],
              }
            }
            if (!(userId in userWorkCount)) {
              userWorkCount[userId] = {}
            }
            if (typeof(userWorkCount[userId]['work']) == 'undefined') {
              userWorkCount[userId]['work'] = 0
            }
            schedules.forEach((scheduleTmp) => {
              userWorkCount[userId]['work'] += this.getWorkForShift(_.get(scheduleTmp, 'shift'), _.get(scheduleTmp, 'status'))
              userDateStatus[userId][date].items.push({
                shift: _.get(scheduleTmp, 'shift'),
                description: _.get(scheduleTmp, 'description'),
                startHour: _.get(scheduleTmp, 'startHour', null),
                endHour: _.get(scheduleTmp, 'endHour', null),
                status: _.get(scheduleTmp, 'status'),
                id: _.get(scheduleTmp, 'id'),
                date,
              })
            })
          })
        }
        const ministryList = this.filterForm.ministryIds.length ?
          this.ministries.filter(d => this.filterForm.ministryIds.includes(d.id)) : this.ministries
        ministryList.forEach((ministry, index) => {
          const users = _.get(ministry, 'users', [])
          if (users) {
            users.forEach((user, userIndex) => {
              tmpItem = {
                name: _.get(ministry, 'name', ''),
                rowspan: users.length,
                id: `${_.get(ministry, 'id')}_${_.get(user, 'id')}`,
                index: userIndex,
                fullName: _.get(user, 'fullName'),
                userId: _.get(user, 'id'),
                ministryId: _.get(ministry, 'id')
              }
              tmp = _.get(user, 'id')
              if (tmp in userDateStatus) {
                  tmpItem['work'] = userWorkCount[tmp]['work']
                _.forEach(userDateStatus[tmp], function (tmpItemLoop, date) {
                  tmpItemLoop.countItems = tmpItemLoop.items.length
                  tmpItem[date] = tmpItemLoop
                })
              }
              dataCalendarItems.push(tmpItem)
            })
          }
        })
        this.dataCalendarItems = dataCalendarItems
        // convert level 2
        if(this.listOrgLv2 && this.listOrgLv2.length){
          let dataOrgLv2 = {
            // lv2_15: {
            //   index: 0, rowspan: 2, name: 'Dao Tao V2'
            // }
          }
          for(let i = 0; i <this.listOrgLv2.length; i++){
            let itemOrgLv2 = this.listOrgLv2[i]
            if(!dataOrgLv2[`lv2_${itemOrgLv2.orgId}`]){
              dataOrgLv2[`lv2_${itemOrgLv2.orgId}`] = {
                index: -1, rowspan: 0, name: itemOrgLv2.name, userId: 0
              }
            }
            for(let j = 0; j < itemOrgLv2.children.length; j++){
              for(let k = 0; k < dataCalendarItems.length; k++){
                if(dataCalendarItems[k].ministryId == itemOrgLv2.children[j].id ){
                  if(dataOrgLv2[`lv2_${itemOrgLv2.orgId}`].index < 0){
                    dataOrgLv2[`lv2_${itemOrgLv2.orgId}`].index = dataCalendarItems[k].index
                  }
                  if(dataCalendarItems[k].index == 0){
                    dataOrgLv2[`lv2_${itemOrgLv2.orgId}`].rowspan += dataCalendarItems[k].rowspan
                    if(!dataOrgLv2[`lv2_${itemOrgLv2.orgId}`].userId){
                      dataOrgLv2[`lv2_${itemOrgLv2.orgId}`].userId = dataCalendarItems[k].userId
                    }

                  }

                }
              }
            }
          }
          this.listOrgLv2Mapping = {}
          for(let _lv2 in dataOrgLv2){
            this.listOrgLv2Mapping[`userId${dataOrgLv2[_lv2].userId}`] = {
              rowspan: dataOrgLv2[_lv2].rowspan, name: dataOrgLv2[_lv2].name
            }
          }
        }
      },
      openNewForm () {
        this.scheduleChoose = {};
        this.newDialog = true
      },
      async getUsers() {
        const res = await OrganizationMachineRepository.listUserByOrgLeve3({
          status: 'active',
          schoolLevelId: this.$store.state.module.schoolLevelId,
          typeId: this.$store.state.module.typeId
        })

        if (res.success) {
          let listUsers = _.get(res, 'data', [])
          const groupUsers = [];
          const groupMinistries = []
          listUsers.forEach(ministry => {
            if (!_.isEmpty(ministry) && ministry.name != 'Inactive') {
              groupMinistries.push({
                id: ministry.id,
                name: ministry.name,
                users: ministry.users
              })
            }

            const { users = [] } = ministry;
            if (users.length) {
              groupUsers.push({
                header: ministry.name,
                name: _.get(ministry, 'name'),
                ministryId: ministry.id,
              });
              users.forEach(user => {
                groupUsers.push({
                  fullName: _.get(user, 'fullName'),
                  group: _.get(ministry, 'name'),
                  id: user.id,
                  avatar: _.get(user, 'avatar.filePath'),
                  ministryId: ministry.id,
                });
              });
            }
          });
          this.groupUsers = groupUsers;
          this.ministries = groupMinistries;
        } else {
          this.$swal({
            title: 'Lỗi!',
            text: _.get(res, 'message', '')
          })
        }
      },
      async orgLevel2() {
        const res = await OrganizationMachineRepository.listOrgLeve2({
          status: 'active',
          schoolLevelId: this.$store.state.module.schoolLevelId,
          typeId: this.$store.state.module.typeId
        })

        if (res.success) {
          this.listOrgLv2 = _.get(res, 'data', [])
        } else {
          this.$swal({
            title: 'Lỗi!',
            text: _.get(res, 'message', '')
          })
        }
      },

      getClassNameItems (items) {
        return 'bg-schedule-' + items.length
      },
      getClassNameByStatus (item) {
        const { status, shift } = item
        if (status === 'off') {
          return 'bg-off'
        }
        if (status === 'halfway_off') {
          return 'bg-halfway-off'
        }
        if (shift === 'morning') {
          return 'bg-morning'
        }
        if (shift === 'afternoon') {
          return 'bg-afternoon'
        }
        if (shift === 'discontinuous') {
          return 'bg-break'
        }
        if (shift === 'all_day') {
          return 'bg-all'
        }
        if (shift === 'evening') {
          return 'bg-evening'
        }
        return ''
      },
      getTextToDisplay (item) {
        if(item) {
          const { status, shift } = item
          if (status === 'off') {
            return 'N'
          }
          if (status === 'halfway_off') {
            return 'K'
          }
          if (shift === 'morning') {
            return 'S'
          }
          if (shift === 'afternoon') {
            return 'C'
          }
          if (shift === 'discontinuous') {
            return 'G'
          }
          if (shift === 'all_day') {
            return 'V'
          }
          if (shift === 'evening') {
            return 'T'
          }
        }
        return ''
      },
      openCreateForm(dataCalendarItem, dateValue) {
        this.scheduleChoose = {
          user: dataCalendarItem.fullName,
          userId: dataCalendarItem.userId,
          date: dateValue,
          ministryId: dataCalendarItem.ministryId,
        };
        this.newDialog = true;
      },
      openEditForm (dataCalendarItem, item) {
        if (!this.checkAuthorization('schedule_update')) {
          return;
        }
        const scheduleDetail = {
          scheduleId: item.id,
          shift: item.shift,
          status: item.status,
          user: dataCalendarItem.fullName,
          userId: dataCalendarItem.userId,
          ministryId: dataCalendarItem.ministryId,
          startHour: item.startHour || null,
          endHour: item.endHour || null,
          date: item.date,
          description: item.description,
        }
        Bus.$emit('schedule-show-edit-form', scheduleDetail)
      },
      updateCalendarDataDependsOn () {
        this.colDates = _.get(this.currentWeekData, 'daynamesMapping.nameHeaders', {})
        this.weekName = _.get(this.currentWeekData, 'weekName', {})
      },
      nextWeek () {
        let lastDate = _.get(this.currentWeekData, 'end')
        lastDate = moment(lastDate).add(1, 'day')
        this.currentWeekData = this.getCurrentWeek(lastDate)
        this.weekName = _.get(this.currentWeekData, 'weekName', {})
        this.month_picker = ''
      },
      previousWeek () {
        let startDate = _.get(this.currentWeekData, 'start')
        startDate = moment(startDate).subtract(1, 'day')
        this.currentWeekData = this.getCurrentWeek(startDate)
        this.weekName = _.get(this.currentWeekData, 'weekName', {})
        this.month_picker = ''
        // this.updateCalendarDataDependsOn()
      },
      async fetchTableData () {
        // this.loading = this.$loading.show()
        this.appLoadingData(true)
        const params = {
          startAt: _.get(this.currentWeekData, 'start'),
          endAt: _.get(this.currentWeekData, 'end'),
          ministryIds: this.filterForm.ministryIds ? this.filterForm.ministryIds : [],
          shift: this.filterForm.shift ? this.filterForm.shift : '',
          schoolLevelId: this.$store.state.module.schoolLevelId,
          typeId: this.$store.state.module.typeId
        };
        
        const response = await ScheduleRepository.list(params);
        if (response.error) {
          this.scheduleList = []
          this.$swal({
            title: 'Lỗi!',
            text: _.get(response, 'message', '')
          })
        } else {
          this.scheduleList = _.get(response, 'data', [])
          // this.sticky_name = parseInt(this.$refs.th_team.clientWidth)
          // this.sticky_work = parseInt(this.$refs.th_name.clientWidth) + this.sticky_name

          // this.sticky_name = this.$refs.th_team ? parseInt(this.$refs.th_team.clientWidth) : 0;
          // this.sticky_work = this.$refs.th_team ? parseInt(this.$refs.th_name.clientWidth) + this.sticky_name : this.sticky_name;
          // this.enabledPreNextBtn()
        }
        this.convertDataToViewCalendar()
        // this.loading.hide()
        this.appLoadingData(false)
      },
      getWorkForShift(shift, status) {
        if (status == 'off' || status == 'halfway_off') {
          return 0
        }

        if (shift == 'all_day' || shift == 'discontinuous') {
          return 1
        } else {
          return 0.5
        }
      },
      getHeightTable() {
        let heightTable = document.querySelector('.table-calendar-container')
        let heightFilter = document.querySelector('.schedule-filter')
        heightFilter = heightFilter && heightFilter.clientHeight ? heightFilter.clientHeight: ''
        let heightInfo = document.querySelector('.schedule-info')
        heightInfo = heightInfo && heightInfo.clientHeight ? heightInfo.clientHeight : ''
        let totalHeader = heightFilter + heightInfo + 75 + 'px'
        heightTable.style.height = `calc(100vh - ${totalHeader})`
      }
    },
  }
</script>
<style lang="scss" scope>
  #schedule-list {
    padding: 0px 15px;
  }
  .bg-schedule {
    width: 100%;
    height: 100%;
    position:absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0 !important;
  }
  .schedule-div-cell {
    width: 100%;
    height: 100%;
    float: left;
    background: #bdbdbd;
    /*color: #fff;*/
  }
  .display-none {
    display: none;
  }
  .table-calendar {
    border-collapse: separate;
    width: 100%;
    overflow: auto;
    border-spacing: 0px;
    tr {
      height: 1px;
    }
    td, th {
      padding: 5px;
      text-align: center;
      min-width: 120px;
      div {
        padding: 5px;
        text-align: center;
      }
    }
    th {
      color: #FFF;
      background: #9E9E9E;
      font-weight: normal;
      position: sticky;
      z-index: 3;
      top: 0px;
      min-width: 120px;
      border-bottom: 1px solid #000;
      border-left: 1px solid #000;
      border-top: 1px solid #000;
      &.scroll-layout-left {
        position: sticky;
        position: -webkit-sticky;
        z-index: 4;
        border-right: 1px solid black !important;
        left: 0px;
      }
      &:last-child {
        border-right: 1px solid #000;
      }
    }
    td {
      position: relative;
      border-bottom: 1px solid #000;
      border-left: 1px solid #000;
      &.scroll-layout-left {
        position: sticky;
        position: -webkit-sticky;
        z-index: 1;
        border-right: 1px solid black !important;
        left: 0px;
        background-color: white
      }
      &:last-child {
        border-right: 1px solid #000;
      }
    }
    .no-padding {
      padding: 0 !important;
    }
  }
  .bg-morning {
    background: #ffab91;
  }
  .bg-afternoon {
    background: #ffab91;
  }
  .bg-break {
    background: #c0ca33;
  }
  .bg-all {
    background: #fff;
  }
  .bg-evening {
    background: #42a5f5;
  }
  .bg-halfway-off {
    background: #616161;
    color: transparent;
  }
  .bg-off {
    background: #bdbdbd;
    color: transparent;
  }
  .bg-schedule-6 {
    .schedule-div-cell {
      width: 16.6666%
    }
  }
  .bg-schedule-5 {
    .schedule-div-cell {
      width: 20%
    }
  }
  .bg-schedule-4 {
    .schedule-div-cell {
      width: 25%
    }
  }
  .bg-schedule-3 {
    .schedule-div-cell {
      width: 33.3333333%
    }
  }
  .bg-schedule-2 {
    .schedule-div-cell {
      width: 50%
    }
  }
  .bg-schedule-1 {
    .schedule-div-cell {
      width: 100%
    }
  }
  .bg-color {
    width: 100%;
    height: 100%;
    border: 1px solid #ccc;
  }
  .s-shift {
    height: 20px !important;
    min-width: 30px !important;
    width: 30px !important;
    border-radius: 0 !important;
    .bg-schedule-title {
      height: 15px !important;
      min-width: 20px !important;
      width: 20px !important;
      border: 1px solid #ccc;
    }
    &.v-avatar--left {
      margin-left: 0 !important;
    }
  }
  .calendar-choose-week-block {
    border-bottom: 1px solid #d2d2d2;
    //margin-top: -13px;
    label {
      font-size: 11px;
    }
    .btn-calendar-group {
      margin-left: -20px;
    }
  }
  .table-calendar-container {
    overflow: auto;
  }
</style>
